import React, { useState, useEffect } from 'react';
import moment from "moment";
import { BsForm, BsFormControl, BsButton } from '../../collection/bootstrap/BootstrapComponents';
import { apiUrl, apiGet } from '../../utils/api';
import { notify, swalertConfirm } from '../../utils/notifications';
import InputEstado from '../../components/project/InputEstado';

export default function ExcelHorasExtra(props) {
    // last time generated
    const [lastTimeGenerated, setLastTimeGenerated] = useState();

    useEffect(() => {
        const fetchLastTime = async () => {
            const result = await apiGet("horasExtras/getLastTimeGenerated");
            setLastTimeGenerated(result);
        };
        fetchLastTime();
    }, []);

    const descargarExcel = async () => {
        const ok = await swalertConfirm(
            "¿Confirma generar excel de horas extras?",
            "Se generará un excel con las horas extras a partir del " +
            moment.utc(lastTimeGenerated?.timestamp).local().format("DD/MM/YYYY")
        );
        if (ok) {
            window.location.replace(apiUrl("horasextras/excel"));
        }
    };

    //  initial values
    const updateData = () => {
        return { from: "", to: "" };
    };
    // save excel between dates
    const saveData = async (formData) => {
        const from = formData.get("from");
        const to = formData.get("to");

        if (from) {
            const params = {
                from: from,
                to: to,
                pendiente: formData.get("pendiente"),
                validado: formData.get("validado")
            };
            window.location.replace(apiUrl("horasextras/excelDates", params));
        } else {
            notify("Elija unas fechas", 'warning');
        }
    }

    // render
    return <>
        <h2>Excel de horas extra</h2>

        <BsButton className="mt-3 mb-5" onClick={descargarExcel}>Generar Excel desde última generación</BsButton>

        <div className="mt-5">
            <BsForm
                onUpdate={updateData}
                onSave={saveData}
                saveOnEnter>
                <ExcelFilterForm />
            </BsForm>
        </div>
    </>;
}

function ExcelFilterForm(props) {
    return <>
        <div className="mt-3 row">
            <div className="col-4">
                <BsFormControl
                    label="Desde" type="date" name="from"
                    column="0" />
            </div>

            <div className="col-4">
                <BsFormControl
                    label="Hasta" type="date" name="to"
                    column="0" />
            </div>

            <div className="col-4">
                <InputEstado />
            </div>
        </div>

        <BsButton
            onClick={props.onSubmit}
            isLoading={props.isSaving}
            className="mt-3">
            Generar Excel entre fechas
        </BsButton>
    </>;
}
